import { updateDetailTaskSummaryAttribute } from '@process-advisor/process-miner/processMiner/processMiner';

export type TaskAttributeProps = {
    attribute?: string;
}

export const changeDetailTaskSummaryAttribute = ({
    attribute,
}: TaskAttributeProps) => updateDetailTaskSummaryAttribute({
    attribute,
});
